import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, Subscription, forkJoin, of } from 'rxjs';
import { catchError, debounceTime, filter, finalize, map, takeUntil, tap } from 'rxjs/operators';

import { AppConfig, ParameterData, WindowService, CustomDatepickerI18n } from '../../../../_helpers/index';
import { CustomerService, DebtorService, InvoicesService, BackFilterService, DebtorDataService, ExcelDateConvertService, PayoutService, UserService, I18n, AuthService } from '../../../../_services';
import { Status, Creation } from '../../../../_enums/invoice';
import { BatchProcessUrls } from '../../../../_enums/urls';
import { Configuration, InvoiceReportExport, PaymentConfigurationValues, QueryParamsList, User } from '../../../../_models';

import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { ConfigurationsKey } from 'src/app/_enums/configurations-key.enums';
import { ErrorTableMessage, NoDataTableMessage } from './payment-invoice-list.constants';

@Component({
  selector: 'app-new-invoices-payment-list',
  templateUrl: './new-invoices-list.component.html',
  styleUrls: ['./new-invoices-list.component.css', '../../../../../assets/css/new-component-view.css', '../../../../../assets/css/new-invoice-list-table.css', '../../../../sharedcomp/sidebar/sidebar.component.css', '../../../../../assets/css/new-date-range-picker.css', '../../../../../assets/css/new-buttons-theme.css'],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})

export class NewInvoicesPaymentListComponent implements OnInit, OnDestroy, AfterViewInit {

  public customer_public_id: string;

  totalSize: any;
  ddlStatus: any[];
  ddlCreation: any[];

  public pageStartDate: any;
  public pageEndDate: any;

  searchFilterForm: FormGroup;
  public displayedColumns: string[] = [];
  public displayedEmptyColumn: string[] = ['empty-row'];
  public dataSourceInvoicesList = new MatTableDataSource();
  public emptyData = new MatTableDataSource([{ empty: "row" }]);
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue: string;
  isRangoVisiable = false;
  isExpirationVisiable = false;
  isOverdueVisiable = false;
  isRangoStatus = "None";
  pageSize: any;
  pageIndex: number = 0;
  pageStart: number = 0;
  PageSizeOptions: number[];
  offsetTimeZone: number ;
  offsetMinutes: number;
  offsetTimeVal: number;
  searchValue: string  = '';
  anularDis: boolean = false;
  tempInvoiceStatus: any;
  userDetails: User;
  isExportExcelAvailable = true;
  isImportAvailable: boolean = false;
  isCreateAvailable: boolean = false;
  isUpdateAvailable: boolean = true;
  isDeleteAvailable: boolean = true;
  isReadAvailable: boolean = true;
  kashioApplication: string;
  invoiceRejectForm: FormGroup;
  rejectInvoiceId: any;
  paymentCodeConfiguration: any;
  isPaymentCodeConfiguration: boolean = false;
  statusDropdownValue = 0;
  creationDropdownValue = 3;
  statusFormControl = new FormControl(0);
  creationFormControl = new FormControl(0);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsList = {};
  snapshotQueryParam: QueryParamsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;

  baseURL: string;
  timerId: any;
  isExportDataAvailable: undefined | InvoiceReportExport;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$: Subscription;
  configurationDetails: any;

  icons: Record<string, Record<string, string>>;
  isSidebarVisible: boolean = false;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  showOverlay: boolean = false;
  displayMonths: number;

  isInvoiceMinimumPaymentAvailable: boolean = false;

  checkPaymentCodeConfiguration$: Observable<Configuration>;
  partialPaymentInvoiceConfiguration$: Observable<Configuration<PaymentConfigurationValues>>;

  private destroy$ = new Subject<void>();
  public isTableLoading: boolean = false;
  public showRetryBtn: boolean = false;
  public readonly noDataTableMessage = NoDataTableMessage;
  public readonly errorTableMessage = ErrorTableMessage;

  constructor
    (
      private router: Router, private formBuilder: FormBuilder
      , private _fb: FormBuilder
      , private parameterData: ParameterData
      , private customerService: CustomerService
      , private invoicesService: InvoicesService
      , private creation: Creation
      , private status: Status
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private payoutService: PayoutService
      , private userService: UserService
      , private debtorDataService: DebtorDataService
      , private backFilterService: BackFilterService
      , private activatedRoute: ActivatedRoute
      , private renderer: Renderer2
      , private windowService: WindowService
  ) {
    this.icons = icons;
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddlCreation = this.creation._newCreation;
    this.ddlStatus = status._status;
    this.InitialSetup();
    this.initSearchForm();
    this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V2;
  }

  ngOnInit() {
    this.checkThisPageGrants();
    this.kashioApplication = localStorage.getItem('application');
    let companyIdStorage = localStorage.getItem('companyId');
    let subCompanyIdStorage = localStorage.getItem('subcompanyId');
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;

    if (browserStorage1 == null && (companyIdStorage != null && companyIdStorage !== '')) {
      this.customer_public_id = companyIdStorage;
    } else if (browserStorage1 != null && (subCompanyIdStorage != null && subCompanyIdStorage !== '')) {
      this.customer_public_id = subCompanyIdStorage;
    } else if ((companyIdStorage == null || companyIdStorage === '') && (subCompanyIdStorage == null || subCompanyIdStorage === '')) {
      this.router.navigate(['/home']);
    }

    let browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;

    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : Number(browserStorage.getItem('timezone'));
    if (this.offsetTimeZone == null || (typeof this.offsetTimeZone === 'string' && this.offsetTimeZone === 'undefined') || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
    } else {
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);
      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal.toString();
    }

    this.displayMonths = window.innerWidth > 900 ? 2 : 1;
    this.listenWindowWidth();

    this.tempInvoiceStatus = 'all';
    this.pageStartDate = this.setTodayValueFilter('00:00:00');
    this.pageEndDate = this.setTodayValueFilter('23:59:59');

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "Siguiente página";
    this.paginator._intl.lastPageLabel = "Ultima página";
    this.paginator._intl.previousPageLabel = "Anterior página";
    this.paginator._intl.firstPageLabel = "Primera página";

    this.initCheckPaymentCodeConfiguration();
    this.initPartialPaymentInvoiceConfiguration();

    forkJoin({
      fistRequest: this.checkPaymentCodeConfiguration$,
      secondRequest: this.partialPaymentInvoiceConfiguration$
    })
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe({
      next: ({ fistRequest, secondRequest }) => {
        this.invoiceListColumnsDisplay();
        this.GetCustomerInvoicesList()
      }
    });
  }

  public reloadTable($event: void): void {
    this.getInvoiceList(this.pageStart);
  }

  public showBtn(value: boolean) {
    this.showRetryBtn = value;
  }

  initCheckPaymentCodeConfiguration() {
    this.checkPaymentCodeConfiguration$ = this.customerService.checkPaymentCodeConfigurationObservable(this.customer_public_id)
    .pipe(
      tap(val => {
        if(val !== undefined && val.status === 'ACTIVE') {
          this.isPaymentCodeConfiguration = true;
        }
      }),
      catchError(error => {
        console.error('Failed while trying to get the payment code configuration.' + error.Error)
        return of(null);
      })
    );
  }

  initPartialPaymentInvoiceConfiguration() {
    this.partialPaymentInvoiceConfiguration$ = this.invoicesService.getInvoiceConfiguration(this.customer_public_id, ConfigurationsKey.PARTIAL_PAYMENTS)
    .pipe(
      filter(val => val.values !== undefined && val.values.active !== undefined && val.values.active),
      map(val => val.values.active),
      tap(active => this.isInvoiceMinimumPaymentAvailable = active),
      catchError(error => {
        console.error('Failed while trying to get partial payment invoice configuration.' + error.Error)
        return of(null);
      })
    );
  }

  initSearchForm() {
    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });
  }

  listenWindowWidth() {
    this.windowService.resizeObservable$
      .pipe(
        debounceTime(200),
        takeUntil(this.destroy$)
      )
      .subscribe((e: Event) => {
        this.displayMonths = e.target['innerWidth'] > 900 ? 2 : 1;
      });
  }

  markDisabled = (date: NgbDate, current: {month: number}) => {
    const currentMonth = current.month;
    return date.month !== currentMonth;
  };

  toggleDateRangePicker() {
    this.showOverlay = !this.showOverlay;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isDisabled(date: NgbDate, current: {month: number}) {
    return date.month === current.month;
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  isFromDate(date: NgbDate) {
    return date.equals(this.fromDate);
  }

  isToDate(date: NgbDate) {
    return this.toDate && date.equals(this.toDate);
  }

  selectDateOption(option: number) {
    this.creationFormControl.patchValue(option);
    this.showOverlay = !this.showOverlay;
    if (option !== 9) {
      this.fromDate = null;
      this.toDate = null;
    }
    this.filterCreationDetails(option);
  }

  get filterStatusName(): string {
    const filterStatus = this.ddlStatus.find(item => item.value === this.statusFormControl.value);
    return filterStatus ? filterStatus.name : '';
  }

  selectStatusOption(option: number) {
    this.showOverlay = false;
    this.statusFormControl.patchValue(option);
    this.filterStatusDetails(option);
  }

  cancelCreation(cancel: boolean) {
    if (!cancel) {
      this.isSidebarVisible = cancel;
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  openCreateCustomerSidebar() {
    this.showOverlay = false;
    this.renderer.addClass(document.body, 'modal-open');
    this.isSidebarVisible = true;
  }

  InitialSetup() {
    this.invoiceRejectForm = this._fb.group({
      description: new FormControl('', [Validators.required]),
    })
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceInvoicesList.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  removeSelectedRows() {
    this.selection.selected.forEach(item => {
      this.invoicesService.deleteInvoice(item.public_id)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.getInvoiceList()
      }, error => {
          console.error('Failed! while trying to the invoices delete. ' + error.error);
      });
      this.anularDis = false;
    });
    this.selection = new SelectionModel<Element>(true, []);
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceInvoicesList.data.forEach(row => this.selection.select(row));
  }

  applyFilter() {
    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.searchValue = this.filterValue.toLowerCase().trim();
    this.GetCustomerInvoicesListFilterAndSearch();
  }

  invoiceListColumnsDisplay() {
      if (this.isPaymentCodeConfiguration) {
        this.displayedColumns = ['select', 'debtor.name', 'status', 'ktin', 'total', 'created', 'due_datetime', 'actions'];
      } else {
        this.displayedColumns = ['select', 'debtor.name', 'status', 'total', 'created', 'due_datetime', 'actions'];
      }

      if (this.isInvoiceMinimumPaymentAvailable) {
        const totalValueIndex = this.displayedColumns.indexOf('created');
        const insertionIndex = totalValueIndex === -1 ? this.displayedColumns.length : totalValueIndex + 1;
        this.displayedColumns.splice(insertionIndex, 0, 'metadata.partial_payment');
      }
  }

  GetCustomerInvoicesList() {
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length !== 0) {
      const creationStateInvoiceList = JSON.parse(localStorage.getItem('creationStateInvoiceList'));
      const customCreationInvoiceRange = JSON.parse(localStorage.getItem('customCreationInvoiceRange'));

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if (this.snapshotQueryParam["pageIndex"] !== '') {
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex.toString();
        }
      }

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if (this.snapshotQueryParam["pageSize"] !== '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize.toString();
        }
      }

      if (this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if (this.snapshotQueryParam["startDate"] !== '') {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.pageStartDate;
        }

        if (this.snapshotQueryParam["endDate"] !== '') {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.pageEndDate;
        }

        if (creationStateInvoiceList === 9) {
          this.creationFormControl.setValue(9);
          this.fromDate = customCreationInvoiceRange.fromDate;
          this.toDate = customCreationInvoiceRange.toDate;
        } else {
          this.creationFormControl.setValue(creationStateInvoiceList);
        }
      }

      if (this.snapshotQueryParam["status"] != undefined) {
        this.queryParams.status = this.snapshotQueryParam["status"];
        this.setStatusFormBySnapshotQueryParam(this.queryParams.status);
      }

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] !== '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      }

      this.pageEvent(this.queryParams);
    } else {
      localStorage.setItem('creationStateInvoiceList', '0');
      this.getInvoiceList(this.pageStart, true);
    }
  }

  pageEvent(event: Params) {
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if (event["startDate"]) {
      if (this.startDateFromSnapshotQueryParam) {
        this.queryParams.startDate = event["startDate"];
        this.pageStartDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.pageStartDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.startDate = this.pageStartDate;
      this.queryParams.startDate = this.queryParams.startDate.replace(' ', '-');
    }

    if (event["endDate"]) {
      if (this.endDateFromSnapshotQueryParam) {
        this.queryParams.endDate = event["endDate"];
        this.pageEndDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.pageEndDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.endDate = this.pageEndDate;
      this.queryParams.endDate = this.queryParams.endDate.replace(' ', '-');
    };

    if (event["status"]) {
      this.queryParams.status = event["status"];
      this.tempInvoiceStatus = this.queryParams.status;
    } else {
      this.queryParams.status = this.tempInvoiceStatus;
    }

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.getInvoiceList(this.pageStart);
  }

  setStatusFormBySnapshotQueryParam(status) {
    const statusMap = {
      'all': 0,
      '(1)': 1,
      '(3)': 2,
      '(4)': 3,
      '(5)': 4,
      '(6)': 6,
      '(8)': 5,
      '(10)': 7,
      '(11)': 8,
      '(12)': 9,
      '(15)': 10,
      '(16)': 11,
      '(17)': 12,
    };
    this.statusFormControl.setValue(statusMap[status] || 0);
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit(){
    this.dataSourceInvoicesList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourceInvoicesList.sort = this.sort;
  }

  GetCustomerInvoicesListFilterAndSearch() {
    this.pageStart = 0;
    this.pageIndex = 0;
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.startDate = this.pageStartDate;
    this.queryParams.endDate = this.pageEndDate;
    this.queryParams.status = this.tempInvoiceStatus;
    if (this.searchValue !== '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.pageEvent(this.queryParams);
  }

  filterStatusDetails(status) {
    const statusMapping: Record<number | string, string> = {
      [0]: 'all',
      [1]: '(1)',
      [2]: '(3)',
      [3]: '(4)',
      [4]: '(5)',
      [5]: '(8)',
      [6]: '(6)',
      [7]: '(10)',
      [8]: '(11)',
      [9]: '(12)',
      [10]: '(15)',
      [11]: '(16)',
      [12]: '(17)'
    };

    this.tempInvoiceStatus = statusMapping[status] || '';
    this.GetCustomerInvoicesListFilterAndSearch();
  }

  filterCreationDetails(creation: number) {
    localStorage.setItem('creationStateInvoiceList', creation.toString());

    const currentDate = new Date();

    const currentweekFirstDate = new Date();
    const currentweekLastDate = new Date();
    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    const lastweekFirstDate = new Date();
    const lastweekLastDate = new Date();
    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    const currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    const lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    const currentYearFirstDate = new Date(currentDate.getFullYear(), 0, 1);
    const currentYearLastDate = new Date(currentDate.getFullYear(), 11, 31);

    const lastYearFirstDate = new Date(currentDate.getFullYear() - 1, 0, 1);
    const lastYearLastDate = new Date(currentDate.getFullYear() - 1, 11, 31);

    let startDateVar;
    let endDateVar;

    switch (Number(creation)) {
      case 0: {
        // Today Filter Condition
        currentDate.setDate(currentDate.getDate());
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      }
      case 1:
        // Yesterday Filter Condition
        currentDate.setDate(currentDate.getDate() - 1);
        startDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 2:
        // Current Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 3:
        // Last Week Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 4:
        // Current Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 5:
        // Last Month Filter Condition
        startDateVar = this.convertGMTTime(new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US')));
        endDateVar = this.convertGMTTime(new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US')));
        break;
      case 6:
        // Current Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(currentYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(currentYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 7:
        // Last Year Filter Condition
        startDateVar = this.convertGMTTime(new Date((formatDate(lastYearFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(lastYearLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        break;
      case 8: {
        // All Datas Condition
        startDateVar = '2017-01-01';
        endDateVar = '2030-01-01';
        break;
      }
      case 9: {
        // Custom Filter Condition
        const startDatePicker = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
        const endDatePicker = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
        startDateVar = this.convertGMTTime(new Date((formatDate(startDatePicker, 'yyyy-MM-dd 00:00:00', 'en-US'))));
        endDateVar = this.convertGMTTime(new Date((formatDate(endDatePicker, 'yyyy-MM-dd 23:59:59', 'en-US'))));
        const filterValue = {
          fromDate: this.fromDate,
          toDate: this.toDate
        };
        localStorage.setItem('customCreationInvoiceRange', JSON.stringify(filterValue));
        break;
      }
      default:
        startDateVar = this.setTodayValueFilter('00:00:00');
        endDateVar = this.setTodayValueFilter('23:59:59');
        break;
    }
    this.pageStartDate = startDateVar;
    this.pageEndDate = endDateVar;
    this.GetCustomerInvoicesListFilterAndSearch();
  }

  /****GMT Converstion */
  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      const dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    } else {
      const startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      const startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
  }

  invoicegridActionClick(viewtype, value) {
    const  publicid = value.public_id;
    switch (viewtype) {
      case 'invoiceview':
        this.router.navigate([`/payments/invoices/${publicid}/view`]);
        break;
      case 'invoiceedit':
        this.router.navigate([`/payments/invoices/${publicid}/edit`]);
        break;
      case 'invoicedelete':
        this.onConfirmInvoice(publicid);
        break;
      case 'invoicedupicate':
        this.duplicateInvoiceDetails(publicid, value);
        break;
      default:
        this.router.navigate([`/payments/invoices/${publicid}/view`]);
    }
  }

  duplicateInvoiceDetails(publicid, value) {
    this.parameterData.InvoiceIdParameters = publicid;
    const data = {
      fromPage: 'invoiceList',
      name: value.debtor.name,
      public_id: value.debtor.public_id
    };
    this.debtorDataService.setPreSelectDebtorSharedData(data);
    this.router.navigate(['/invoices/create']);
  }

  onConfirmInvoice(publicid) {
    this.spinnerService.show();
    this.invoicesService.deleteInvoice(publicid)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
        this.getInvoiceList();
      }, error => {
        this.spinnerService.hide();
        console.error('Failed while trying to cancel the invoice Details.' + error);
      });
  }

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == null && this.isErrorExportAvailable == null) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 11000);
  }

  reportExport() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = null;
    this.isErrorExportAvailable = null;

    this.checkResponseExportTime();
    this.exportSubscription$ = this.invoicesService.reportExport(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate,
      this.pageEndDate, this.searchValue)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.isExportDataAvailable = data;
        if (data.storage_url != null) {
          location.href = data.storage_url;
        }
        this.spinnerService.hide();
      }, err => {
        this.spinnerService.hide();
        this.isErrorExportAvailable = err;
        console.error('Failed while trying to export txt file.' + err.error);
      });
  }

  closeModal() {
    this.timeCompleted = false;
  }

  public getInvoiceList(pageStart: number = 0, resetPageIndex: boolean = false): void {
    this.isTableLoading = true;
    this.showBtn(false);
    this.dataSourceInvoicesList.data = [];

    this.invoicesService.getInvoiceList(this.customer_public_id, this.tempInvoiceStatus, this.pageStartDate, this.pageEndDate, this.pageSize, pageStart, this.searchValue)
    .pipe(
      takeUntil(this.destroy$),
      tap(data => {
        try {
          let resources = data["data"];
          if (resetPageIndex) {
            this.paginator.pageIndex = 0;
          }
          this.selection.clear();
          this.dataSourceInvoicesList.data = resources;
          this.totalSize = JSON.parse(data.records);
        } catch (error) {
          console.error(error);
          this.showBtn(true);
        }
      }),
      finalize(() => {
        this.isTableLoading = false;
      }),
      catchError(error => {
        console.error('Failed! while trying to get the invoices list. ' + error.error);
        this.showBtn(true);
        throw error;
      })
    )
    .subscribe();
  }

  rejectInvoice() {
    this.spinnerService.show();
    let rejectDescription = this.invoiceRejectForm.controls['description'].value;
    this.payoutService.rejectInvoice(this.rejectInvoiceId, rejectDescription)
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe(result => {
      this.getInvoiceList();
    },
      error => {
        console.error('Failed while trying to reject the invoice Details.' + error);
      })
  }

  async getUserRoleStatus() {
    try {
      const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
      this.userDetails = data;
    }
    catch (error) {
      console.error('Failed while trying to getUserRoleStatus.' + error)
    }

  }
  async checkPaymentCodeConfiguration() {
    try {
      const data = await this.customerService.checkPaymentCodeConfiguration(this.customer_public_id);
      this.paymentCodeConfiguration = data;
      if (this.paymentCodeConfiguration.status === 'ACTIVE') {
        this.isPaymentCodeConfiguration = true;
      }
    }
    catch (error) {
      console.error('Failed while trying to get the payment code configuration.' + error.error)
    }
  }

  async checkThisPageGrants() {
    await this.getUserRoleStatus();
    await this.auth.isKashioGrantsAvailable();
    this.isExportExcelAvailable = this.auth.checkGrants('INVOICES', 'EXPORT');
    this.isImportAvailable = this.auth.checkGrants('INVOICES', 'IMPORT');
    this.isCreateAvailable = this.auth.checkGrants('INVOICES', 'CREATE');
    this.isUpdateAvailable = this.auth.checkGrants('INVOICES', 'UPDATE');
    this.isDeleteAvailable = this.auth.checkGrants('INVOICES', 'DELETE');
    this.isReadAvailable = this.auth.checkGrants('INVOICES', 'READ');
  }

  setTodayValueFilter(hour: string) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
